import React from 'react';
import PageShell from '../ui/PageShell';
import { PageHeader } from '../ui/PageHeader';
import { NotificationPreferences } from './NotificationCenter';
import PageBackLink from '../ui/PageBackLink';

/**
 * Full-page wrapper for watched-build notification preferences.
 * Mounted at NOTIFICATION_PREFERENCES_PATH (/settings/notifications).
 */
const NotificationPreferencesPage: React.FC = () => (
  <PageShell>
    <PageBackLink label="Back to Garage" to="/garage" className="mb-4" />
    <PageHeader
      eyebrow="Settings"
      title="Build update preferences"
      description="Choose which watched-build updates appear in your notification center."
    />
    <NotificationPreferences />
  </PageShell>
);

export default NotificationPreferencesPage;
